const locale = require('./selectionModal.i18n.json');

/*@ngInject*/
const SelectionModalController = function ($rootScope, $scope, coreMediator, selectionDropdown, options, localization, coreConstant) {


    $scope.i18n = locale;

    $scope.viewModel = {
        title: options.title,
        summary:options.summary,
        ok:options.ok,
        cancel:options.cancel,
        confirm:options.confirm,
        dropdownItems: [],
        selectedPrompt: options.selectedPrimaryPrompt,
        selectedItem : null,
        warningSummary:options.warningSummary
    };

    $scope.onSelectItem = function (item) {
        $scope.viewModel.selectedItem = item;
        $scope.viewModel.selectedPrompt = item.name;
    };

    $scope.onClose = function () {
        var selectedPrimaryReason = '';
        if ($scope.viewModel.selectedItem) {
            selectedPrimaryReason = $scope.viewModel.selectedItem.value;
        }
        $scope.$close($scope.viewModel.selectedItem.value);
    };

    function primaryReasonIsNotSelected() {
        var hasPrimaryReasonSelection = $scope.viewModel.selectedItem && $scope.viewModel.selectedItem.value;
        return !hasPrimaryReasonSelection;
    }

    $scope.isConfirmButtonDisabled = function () {
        return primaryReasonIsNotSelected();
    };

    $scope.showCheckMarkForPrimaryReason = function () {
        return !primaryReasonIsNotSelected();
    };

    coreMediator.getDynamicDataSetItems(selectionDropdown).then(function (result) {
        $scope.viewModel.dropdownItems =  result;
    });

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('selectionModalController', SelectionModalController);
